import isProd from '#helpers/i18n/isProd.js'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
	legacy: false,
	locale: 'en',
	fallbackLocale: isProd() ? 'en' : 'debug',
	messages: {},
})

export default i18n
